import { useId } from 'react'
import { FieldShell } from './internal/FieldShell'
import { describedBy } from './internal/cx'

export type DateFieldProps = {
  label: string
  /** Local date, ISO yyyy-mm-dd. */
  value: string
  onChange: (value: string) => void
  error?: string
}

export function DateField({ label, value, onChange, error }: DateFieldProps) {
  const fieldId = useId()
  return (
    <FieldShell id={fieldId} label={label} error={error}>
      <input
        id={fieldId}
        className="ui-input"
        type="date"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(error && `${fieldId}-error`)}
      />
    </FieldShell>
  )
}
